import React, { useEffect, useState } from "react";
import { Card, CardTitle } from "reactstrap";
import { GlobalContext } from "../../../context/GlobalState";
import { TablesEvent } from "./cardEvents";
import { eventMock } from "./eventMock";

export const Events = (props) => {
  const [allTables, setAllTables] = useState([]);

  useEffect(() => {

  }, []);

  useEffect(() => {
    var allRTables = [];
    props.allSteps.map((e) => {
      var findTable = false;
      allRTables.map((f) => {
        if (f.eventType === e.EventType) {
          f.data.push(e);
          findTable = true;
        }
        return f;
      });
      if (!findTable) {
        if (e.EventType !== "Eventos del Contenedor") {
          var obj = {
            eventType: e.EventType,
            data: [e],
          };
          allRTables.push(obj);
        }
      }
      return e;
    });

    setAllTables(allRTables);
  }, [props]);

  return (
    <div>
      {allTables.length ? (
        <>
          <Card body>
            <CardTitle>
              <legend className="titleCardResumen">Events</legend>
            </CardTitle>
            <div className="row">
              {allTables[0] ? (
                <div className="col-md-12 col-lg-12 col-sm-12">
                  <div className="row">
                    <div className="col-md-6">
                      <legend className="titleCardResumen">Booking</legend>
                    </div>
                  </div>
                  {/* <Collapse isOpen={isOpen}> */}
                    <TablesEvent columns={eventMock.columns} allTables={[allTables[0]]} />
                  {/* </Collapse> */}
                </div>
              ) : (
                ""
              )}

              {allTables[1] ? (
                <div className="col-md-12 col-lg-12 col-sm-12">
                  <div className="row">
                    <div className="col-md-6">
                      <legend className="titleCardResumen">Origin</legend>
                    </div>
         
                  </div>
                  {/* <Collapse isOpen={isOpenOrigen}> */}
                    <TablesEvent
                      columns={eventMock.columns}
                      allTables={[allTables[1]]}
                    />
                  {/* </Collapse> */}
                </div>
              ) : (
                ""
              )}

              {allTables[2] ? (
                <div className="col-md-12 col-lg-12 col-sm-12">
                  <div className="row">
                    <div className="col-md-6">
                      <legend className="titleCardResumen">Destination</legend>
                    </div>
                  </div>
                  {/* <Collapse isOpen={isOpenDestino}> */}
                    <TablesEvent
                      columns={eventMock.columns}
                      allTables={[allTables[2]]}
                    />
                  {/* </Collapse> */}
                </div>
              ) : (
                ""
              )}
            </div>
          </Card>
        </>
      ) : (
        ""
      )}
    </div>
  );
};
